import React, { Component } from 'react'
import './App.css'
// Principais CSS para base do projeto
import './styles/alert.css'
import './styles/reset.css'
import './styles/index.css'
import './styles/modal.css'

import firebase from './server/firebase.js'

import Noty from 'noty'

import Login from './components/Login'
import Dashboard  from './components/Dashboard'
import PaypalExpressBtn from 'react-paypal-express-checkout';


class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      login : '',
      user: ''
    }

    this.closeLogin = this.closeLogin.bind(this)
  }


  componentDidMount() {

    var ref = this

    firebase.auth().onAuthStateChanged(function(user) {

      if(user){
        console.log('opaaa2')
        ref.setState({
          user:  user
        })
      } else {
        console.log('opaaa')
        ref.setState({
          login: <Login closeLogin={ref.closeLogin} />
        })
      }
    })

    ref.setState({
      login: ''
    })
  }

  closeLogin(){

    this.setState({
      login: ''
    })
  }

  render() {

    return (
      <div className="App">
        {this.state.login}
        <Dashboard/>
      </div>
    );
  }
}

export default App;

Noty.overrideDefaults({
  layout   : 'topRight',
  theme    : 'bootstrap-v3',
  closeWith: ['click'],
  timeout: 2000
})



// WEBPACK FOOTER //
// ./src/App.js